<template>
  <!-- 这个是游戏数据 -->
  <div class="game_analyse table_border">
    <!-- 这个是 -->
    <div class="condition_box">
      <div class="condition">
        <div class="seek_input_box">
          <div class="seek_text">
            {{ $t("operational_data.game_analyse.app") }}
          </div>
          <el-select
            :disabled="DataMeta.length > 0 ? false : true"
            :no-data-text="$t('operational_data.no_result')"
            class="order_win"
            v-model="appNamestate"
            :placeholder="$t('operational_data.game_analyse.select')"
          >
            <el-option
              v-for="(item, index) in DataMeta"
              :value="item.appId.toString()"
              :key="index"
              :label="item.appName"
            ></el-option>
          </el-select>
        </div>

        <div class="select_i8">
          <div class="seek_input_box" v-if="platforms.length > 0">
            <div class="seek_text">
              {{ $t("operational_data.game_analyse.platform") }}
            </div>
            <el-select
              style="height: 40px; width: 210px"
              size="large"
              mode="tags"
              v-model="selectplatforms"
            >
              <el-option
                v-for="(item, index) in platforms"
                :value="item.value.toString()"
                :key="index"
                :label="item.label"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="select_i8">
          <div class="seek_input_box" v-if="gameName.length > 0">
            <div class="seek_text">
              {{ $t("operational_data.game_analyse.gameName") }}
            </div>
            <el-select
              :no-data-text="$t('operational_data.no_result')"
              :placeholder="$t('operational_data.game_analyse.select')"
              class="order_win"
              v-model="selectgameName"
            >
              <el-option
                v-for="(item, index) in gameName"
                :value="item.id.toString()"
                :key="index"
                :label="item.name"
              ></el-option>
            </el-select>
          </div>
        </div>

        <div class="seek_input_box mg_top20" v-if="startValue != null">
          <div class="seek_text">
            {{ $t("operational_data.game_analyse.dateRange") }}
          </div>
          <div class="date_picker_box">
            <!--  <div  v-if="startValue != null">
              <a-date-picker
                :default-value="moment(startValue, 'YYYY-MM-DD')"
                format="YYYY/MM/DD "
                :locale="locale"
                    :disabled-date="disabledStartDate"
                    show-time
                    @openChange="handleStartOpenChange"
                    style="width: 90px;height: 40px;"
                    @change='startValueChange'
                  />
            </div>
          <div  v-if="endValue  != null">
             <a-date-picker
             :default-value="moment(endValue, 'YYYY-MM-DD')"
            format="YYYY/MM/DD "
              :locale="locale"
               :disabled-date="disabledEndDate"
               show-time
               :open="endOpen"
               @openChange="handleEndOpenChange"
               style="width: 90px;height: 40px;"
               @change='endValueChange'
             />
           </div> -->
            <div>
              <a-range-picker
                show-time
                format="YYYY-MM-DD"
                :locale="locale"
                :disabled-date="disabledDate"
                @calendarChange="calendarPriceRangeChange"
                @change="changePriceRangeDate"
                :default-value="[
                  moment(startValue, 'YYYY-MM-DD'),
                  moment(endValue, 'YYYY-MM-DD'),
                ]"
              >
                <a-icon slot="suffixIcon" type="calendar" />
              </a-range-picker>
            </div>
          </div>
        </div>
        <!-- -->
        <div class="condition_btn CU mg_top20" @click="getLoadUserGameData">
          {{ $t("operational_data.game_analyse.Apply") }}
        </div>
      </div>
    </div>
    <div class="data_title">
      {{ $t("operational_data.game_analyse.gameAnalysis") }}
    </div>

    <div class="switch_box">
      <div class="switchs">
        <div class="switch_list">
          <div
            class="switch CU"
            @click="switch_cut(1)"
            :class="switchSelect == 1 ? 'switch_active' : ''"
          >
            {{ $t("operational_data.game_analyse.gameUsers") }}
          </div>
          <div
            class="switch CU"
            @click="switch_cut(2)"
            :class="switchSelect == 2 ? 'switch_active' : ''"
          >
            {{ $t("operational_data.game_analyse.averageGameLaunchTimes") }}
          </div>
        </div>
        <div class="export_btn CU" @click="exportData">
          {{ $t("operational_data.game_analyse.exportData") }}
        </div>
      </div>

      <!-- 对应展示的内容 -->
      <div
        class="switch_centent"
        v-if="gameUsers.length > 0"
        style="width: 1000px; height: 370px"
      >
        <a-carousel
          easing="linear"
          :after-change="onChange"
          :edgeFriction="300"
          ref="varousel"
        >
          <div style="width: 1000px; height: 370px">
            <charts
              v-if="switchSelect == 1"
              :istoFixed="false"
              :message="gameUsers"
              :text="$t('operational_data.game_analyse.gameUsers')"
            ></charts>
          </div>
          <div style="width: 1000px; height: 370px">
            <charts
              v-if="switchSelect == 2"
              :istoFixed="true"
              :message="averageGameLaunchTimes"
              :text="$t('operational_data.game_analyse.averageGameLaunchTimes')"
            ></charts>
          </div>
          <div style="width: 1000px; height: 370px; display: none"></div>
        </a-carousel>
      </div>

      <div class="chartsBG" v-else>
        <img class="chartsBG_img" src="@/img/moe.jpg" alt="" />
        <!-- <div class="chartsBG_text">Please input retention parameter to make simulation</div> -->
      </div>
    </div>
    <div>
      <div class="gamelist_table">
        <a-config-provider>
          <template
            v-if="datalist == '' && !tableloading"
            #renderEmpty
            style=""
          >
            <div style="text-align: center; margin-top: 100px">
              <img src="@/img/kong.png" alt="" />
              <p>{{ $t("operational_data.no_result") }}</p>
            </div>
          </template>

          <template v-if="datalist == '' && tableloading" style="">
            <div style="text-align: center; margin-top: 100px">
              <loading></loading>
            </div>
          </template>
          <!--           @change="handleTableChange" -->
          <a-table
            :pagination="pagination"
            :columns="columns"
            :data-source="datalist"
            :rowKey="
              (record, index) => {
                return index;
              }
            "
          >
            <template slot="date" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="cumulativeUsers" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="daUsers" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="newUsers" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="newUserRate" slot-scope="text, record, index">
              {{ text }}
            </template>
          </a-table>
        </a-config-provider>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import charts from "@/components/Operational_data/views/chart";
import moment from "moment";
import "moment/locale/zh-cn";
import EN from "ant-design-vue/es/date-picker/locale/en_US";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import loading from "@/components/loading/loading.vue";
export default {
  components: {
    charts,
    loading,
  },
  data() {
    return {
      pagination: {
        defaultCurrent: 1,
        total: 0,
        pageSize: 30, //每页中显示20条数据
        // showTotal:0,
        // showSizeChanger: true,
        // pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
        // showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
      },
      locale: EN,
      DataMeta: [],
      gameName: [],
      platforms: [
        { value: "", label: "All" },
        { value: "1", label: "Android" },
        { value: "2", label: "iOS" },
        { value: "3", label: "Web" },
      ],
      selectplatforms: "",
      defaultPlatforms: "",
      selectgameName: "",
      appNamestate: "",
      initData: [],
      yeserday: {},
      startValue: null,
      endValue: null,
      maxEndDate: null,
      endOpen: false,
      switchSelect: 1,
      datalist: [],
      columns: this.dayData(),
      tableloading: false,
      gameUsers: [],
      averageGameLaunchTimes: [],
      priceRangeDate: [],
      selectPriceDate: "",
      offsetDays: 86400000 * 183, //最多选择7天
    };
  },
  async created() {
    await this.getAppList();
    this.getLoadUserGameData();
  },
  mounted() {
    if (this.$i18n.locale == "zh") {
      moment.locale("zh-cn");
      this.locale = locale;
    } else {
      moment.locale("en_US");
      this.locale = EN;
    }
  },
  watch: {
    appNamestate: {
      handler: "getAppGameList",
      immediate: true,
    },
  },
  methods: {
    ...mapActions("game", [
      "LoadActDataNew",
      "LoadDataMeta",
      "ExportUserGameData",
      "AppList",
      "AppGameList",
    ]),
    moment,
    //选择完时间 清空限制
    changePriceRangeDate(dates, dateStrings) {
      this.selectPriceDate = "";
      this.startValue = new Date(dateStrings[0]).getTime();
      this.endValue = new Date(dateStrings[1]).getTime();
    },
    //选择开始时间/结束时间
    calendarPriceRangeChange(date) {
      this.selectPriceDate = date[0];
    },
    //根据选择的开始时间/结束时间，动态渲染要禁用的日期
    disabledDate(current) {
      if (this.selectPriceDate) {
        let selectV = moment(this.selectPriceDate, "YYYY-MM-DD").valueOf();
        return (
          current > moment(new Date(this.maxEndDate), "YYYY-MM-DD") ||
          current > moment(new Date(selectV + this.offsetDays), "YYYY-MM-DD") ||
          current < moment(new Date(selectV - this.offsetDays), "YYYY-MM-DD")
        );
      } else {
        return current > moment(new Date(this.maxEndDate), "YYYY-MM-DD");
      }
    },
    async getAppList() {
      const res = await this.AppList({
        $axios: this.$axios,
      });
      if (res.code == 200) {
        let data = res.data;
        let newDate = [...data];
        this.DataMeta = newDate;
        this.appNamestate = newDate[0].appId;
        const currentDate = new Date();
        const previousWeekStartDate = new Date();
        const previousWeekEndDate = new Date();

        // 获取上一周的日期
        previousWeekStartDate.setDate(currentDate.getDate() - 7);
        previousWeekEndDate.setDate(currentDate.getDate() - 1);

        // 格式化日期为 "YYYY-MM-DD" 格式
        const formattedStartDate = this.formatDate(previousWeekStartDate);
        const formattedEndDate = this.formatDate(previousWeekEndDate);

        // 更新数据
        this.previousWeekStartDate = formattedStartDate;
        this.previousWeekEndDate = formattedEndDate;

        this.startValue = this.previousWeekStartDate;
        this.endValue = this.previousWeekEndDate;
        this.maxEndDate = this.previousWeekEndDate;
      }
    },
    async getAppGameList() {
      const res = await this.AppGameList({
        $axios: this.$axios,
        appId: this.appNamestate,
      });
      if (res.code == 200) {
        this.gameName = res.data;
        this.selectgameName = res.data[0] && res.data[0].id;
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // 点击查询数据
    async getLoadUserGameData() {
      if (!this.appNamestate || !this.startValue || !this.endValue) {
        return;
      }

      var self = this;
      this.tableloading = true;
      this.datalist = "";
      const res = await this.LoadActDataNew({
        $axios: this.$axios,
        appId: this.appNamestate,
        platform: this.selectplatforms,
        startDay: this.newdata(this.startValue),
        endDay: this.newdata(this.endValue),
        gameId: this.selectgameName,
      });

      if (res.code == 200) {
        let data = res.data;
        this.datalist = data;
        if (data.length > 0) {
          let date = [];
          let averageGameLaunchTimes = [];
          let gameUsers = [];
          data.forEach((item, index) => {
            averageGameLaunchTimes.push([item.day, item.gameCountAverage]);
            gameUsers.push([item.day, item.gameUser]);
          });
          this.gameUsers = gameUsers;
          this.averageGameLaunchTimes = averageGameLaunchTimes;
        }

        const index = this.switchSelect;
        setTimeout(function () {
          self.switch_cut(index);
        }, 100);

        this.tableloading = false;
      }
    },

    async exportData() {
      if (!this.appNamestate || !this.startValue || !this.endValue) {
        return;
      }
      const res = await this.ExportUserGameData({
        $axios: this.$axios,
        tpAppId: this.appNamestate,
        platform: this.selectplatforms,
        startDate: this.newdata(this.startValue),
        endDate: this.newdata(this.endValue),
      });

      if (res.stateCode == 1) {
        window.open(res.resultInfo.data.downloadUrl);
      }
    },

    newdata(cTime) {
      let date = new Date(cTime);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day;
    },

    switch_cut(index) {
      this.switchSelect = index;
      var self = this;
      if (this.gameUsers.length > 0) {
        this.$refs.varousel.goTo(index - 1);
      }
    },

    dayData() {
      return [
        {
          title: this.$t("operational_data.game_analyse.date"),
          dataIndex: "day",
          key: "day",
          scopedSlots: { customRender: "day" },
          customRender: (text, record) => {
            return text ? text : "-";
          },
        },
        {
          title: this.$t("operational_data.game_analyse.gameUsers"),
          dataIndex: "gameUser",
          key: "gameUser",
          scopedSlots: { customRender: "gameUser" },
          customRender: (text, record) => {
            return text ? text : "-";
          },
        },
        {
          title: this.$t("operational_data.game_analyse.gameLaunchTimes"),
          dataIndex: "gameCount",
          key: "gameCount",
          ellipsis: true,
          scopedSlots: { customRender: "gameCount" },
          customRender: (text, record) => {
            return text ? text : "-";
          },
        },
        {
          title: this.$t(
            "operational_data.game_analyse.averageGameLaunchTimes"
          ),
          dataIndex: "gameCountAverage",
          key: "gameCountAverage",
          ellipsis: true,
          customRender: (text, record) => {
            return text ? text.toFixed(1) : "-";
          },
        },
      ];
    },
  },
};
</script>

<style scoped="scoped">
.game_analyse {
  min-height: 650px;
}
.condition_box {
  margin-top: 33px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 40px;
  margin-bottom: 25px;
}
.condition {
  width: 100%;
  /* height: 70px; */
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  box-sizing: border-box;
  flex-wrap: wrap;
}
.condition_btn {
  width: 90px;
  height: 40px;
  background-color: #4990fa;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #fff;
}
.seek_input_box {
  margin-right: 30px;
  display: flex;
  align-items: center;
}
.seek_text {
  margin-right: 23px;
}
.seek_input {
  width: 241px;
  height: 34px;
}
.date_picker_box {
  display: flex;
}

.data_title {
  padding-left: 40px;
  font-size: 18px;
  font-weight: bold;
  color: #282828;
  margin-bottom: 20px;
}
.btns {
  display: flex;
}

.btn_dow {
  width: 100px;
  height: 32px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  text-align: center;
  line-height: 32px;
  color: #666666;
  font-size: 14px;
  margin-left: 40px;
}
/* 矢量图 */
.switch_box {
  border-top: 1px solid #f3f3f3;
  width: 100%;
  padding-left: 40px;
  padding-top: 20px;
  padding-right: 40px;
}
.switch_list {
  width: 1256px;
  display: flex;
}
.switch {
  text-align: center;
  font-size: 14px;
  color: #666666;
  padding-bottom: 10px;
  border-bottom: 2px solid #fff;
  padding: 0 20px;
  margin-right: 20px;
}
.switch_active {
  color: #5b99fa;
  border-bottom: 2px solid #10a4f1;
}
.gamelist_table {
  margin-top: 60px;
  padding: 0 40px;
}
.switchs {
  display: flex;
}
.export_btn {
  width: 100px;
  height: 32px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #e6e6e6;
  font-size: 14px;
  color: #666666;
  text-align: center;
  line-height: 32px;
}

.mg_top20 {
  margin-top: 20px;
}

.chartsBG {
  width: 100%;
  height: 370px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.chartsBG_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.chartsBG_text {
  font-size: 16px;
  color: #666666;
  position: relative;
  z-index: 2;
}
.ant-carousel >>> .slick-slide {
  text-align: center;
  overflow: hidden;
}
.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
.switch:hover {
  color: #5b99fa;
}
</style>



// WEBPACK FOOTER //
// src/components/Operational_data/game_analyseNew.vue